import React from 'react'
import { PlusIcon } from '../../../../../Component/Icons'
import { MAX_NO_OF_LINE_ITEMS } from '../../../../../Helper/EnhancedData/Constants'
import { formatter } from '../../../../../Helper/Money'

export interface SubtotalRowProps {
  itemCount: number
  subtotal: number
  onAddClick: () => void
  colSpan?: number
  maxItems?: number
}

export function SubtotalRow (props: SubtotalRowProps): React.JSX.Element {
  const {
    itemCount,
    subtotal,
    onAddClick,
    colSpan = 7,
    maxItems = MAX_NO_OF_LINE_ITEMS,
  } = props

  // Format the subtotal to always show 2 decimal places
  const formattedSubtotal = formatter.format(subtotal)

  return (
    <tr className="subtotal-row">
      <td colSpan={colSpan} className="subtotal-cell">
        <div className="subtotal-container">
          <div className="subtotal-left">
            <button
              className="add-product-btn"
              onClick={onAddClick}
              type="button"
            >
              <PlusIcon/>
               Add or Create Product Item
            </button>

            <div className="item-count-text">
              <span><strong>{itemCount}</strong> items entered.</span>
              <span>Cannot exceed {maxItems} items.</span>
            </div>
          </div>

          <div className="subtotal-right">
            <span className="subtotal-label">Subtotal:</span>
            <span className="subtotal-amount">{formattedSubtotal}</span>
          </div>

        </div>
      </td>
    </tr>
  )
}
